import * as SL from "slate";
import { toggleList } from "../components/toolbar/components/list-button/duck";
import { CustomEditor, CustomElement } from "../duck";
import { isElementEmpty } from "./duck";

const withLists = <T extends CustomEditor>(editor: T): T => {
  const { deleteBackward, normalizeNode } = editor;

  editor.deleteBackward = unit => {
    const { selection } = editor;

    if (
      selection &&
      selection.focus.offset === 0 &&
      selection.anchor.offset === 0 &&
      SL.Range.isCollapsed(selection)
    ) {
      const node = editor.children[selection.anchor.path[0]] as
        | CustomElement
        | undefined;
      if (
        (node?.type === "bulleted-list" || node?.type === "numbered-list") &&
        node.children.length === 1
      ) {
        // list items created from pasted text have multiple children elements,
        // all of them must be empty before toggleList usage
        if (isElementEmpty(node.children[0])) {
          toggleList(editor, node?.type, false);
        } else {
          deleteBackward(unit);
        }
      } else {
        deleteBackward(unit);
      }
    } else {
      deleteBackward(unit);
    }
  };

  editor.normalizeNode = entry => {
    const [node, path] = entry;

    if (SL.Element.isElement(node) && node.type === "list-item") {
      const [parentNode] = SL.Editor.parent(editor, path);
      const isParentListItem =
        "type" in parentNode &&
        (parentNode.type === "bulleted-list" ||
          parentNode.type === "numbered-list");

      if (!isParentListItem) {
        SL.Transforms.setNodes(editor, { type: "paragraph" }, { at: path });
        return;
      }
    }

    normalizeNode(entry);
  };

  return editor;
};

export default withLists;
